<template>
  <div class="block block_wide" id="champs">
    <div class="block__intro block__item">
      <div class="block__intro-item">
        <div class="grid grid_v-center grid_v-margins">
          <div class="grid__col grid__col_stretch">
            <h2>Чемпионаты</h2>
          </div>
          <div class="grid__col grid__col_auto" v-show="isLoaded && !empty">
            <router-link
              class="button button_primary button_sm"
              :to="{ name: 'CreateChamp', params: { id: $route.params.id } }"
            >
              <span class="button__text">
                Создать чемпионат
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="block__body block__item block__item_sm" v-if="!isLoaded">
      <div class="loader m-0"></div>
    </div>
    <template v-else>
      <div
        class="block__body block__item block__item_sm"
        v-show="!empty"
      >
        <div class="block__body block__item block__item_sm">
          <div class="input">
            <div class="input__icons">
              <div class="input__icon">
                <icon icon-name="search"></icon>
              </div>
            </div>
            <input
              class="input__el"
              v-model.trim="params.search"
              type="search"
              name="champ"
              autocomplete="off"
              placeholder="Найти чемпионат..."
            >
            <div class="input__border"></div>
            <div class="input__icons" v-show="params.search">
              <button
                class="input__icon input__icon_hover"
                @click.prevent="params.search = null"
                type="button"
              >
                <icon icon-name="close-circle-s"></icon>
              </button>
            </div>
          </div>
        </div>
        <div
          class="block__body block__item block__item_sm"
          style="position: relative"
        >
          <div
            class="overlay overlay_light overlay_flex"
            v-show="loading && pagination.totalItems > 0"
            style="z-index: 2"
          >
            <div class="overlay__content overlay__content_top">
              <div class="loader"></div>
            </div>
          </div>
          <div
            class="block__body block__item block__item_sm"
            v-show="pagination.totalItems < 1"
          >
            <div class="empty-state" v-show="!loading">
              <div class="section__group mt-0">
                <div class="section__item">Нет результатов</div>
              </div>
            </div>
            <div class="loader m-0" v-show="loading"></div>
          </div>
          <div
            class="block__body-item"
            v-if="draftChamps.length"
          >
            <div class="subtitle-1 text-md">Черновики</div>
            <div class="grid grid_v-margins grid_gutters-sm">
              <div
                class="grid__col grid__col_md-12"
                v-for="item in draftChamps"
                :key="item.Id"
              >
                <champ-card
                  :clubId="clubId"
                  :bordered="true"
                  :champ="item"
                  :internal="true"
                  :hideStatus="true"
                  :hideMember="true"
                  :draft="true"
                  :manage="true"
                  @deleted="onChampDelete"
                >
                </champ-card>
              </div>
            </div>
          </div>
          <div
            class="block__body-item"
            v-if="activeChamps.length"
          >
            <div class="subtitle-1 text-md">Активные</div>
            <div class="grid grid_v-margins grid_gutters-sm">
              <div
                class="grid__col"
                v-for="item in activeChamps"
                :key="item.Id"
              >
                <champ-card
                  :clubId="clubId"
                  :bordered="true"
                  :champ="item"
                  :internal="true"
                  :hideStatus="true"
                  :hideMember="true"
                  :manage="true"
                >
                </champ-card>
              </div>
            </div>
          </div>
          <div
            class="block__body-item"
            v-if="finishedChamps.length"
          >
            <div class="subtitle-1 text-md">Завершённые</div>
            <div class="grid grid_v-margins grid_gutters-sm">
              <div
                class="grid__col"
                v-for="item in finishedChamps"
                :key="item.id"
              >
                <champ-card
                  :clubId="clubId"
                  :bordered="true"
                  :champ="item"
                  :internal="true"
                  :hideStatus="true"
                  :hideMember="true"
                  :manage="true"
                >
                </champ-card>
              </div>
            </div>
          </div>
        </div>
        <div
          class="block__body block__item block__item_sm"
          v-show="pagination.totalItems > pagination.itemsPerPage"
        >
          <pagination
            :page="pagination.page"
            :totalItems="pagination.totalItems"
            :itemsPerPage="pagination.itemsPerPage"
            :disabled="pagination.disabled"
            @change="changePage"
          >
          </pagination>
        </div>
      </div>
      <div class="block__body block__item block__item_sm" v-show="empty">
        <section class="empty-state">
          <div class="section__group mt-0">
            <div class="section__item">
              <img :src="$getTenantImg('noChamps')" alt="">
            </div>
            <div class="section__item">
              <div class="text-lg">
                <b>Создайте первый чемпионат</b>
              </div>
              <div class="mt-8">Повысьте интерес к&nbsp;клубу за&nbsp;счёт внутриклубных поэтапных чемпионатов.
                Настройте
                номинации основанные на&nbsp;тренировках участников клуба.
              </div>
            </div>
          </div>
          <div class="section__group">
            <router-link
              class="button button_lg button_primary"
              :to="{ name: 'CreateChamp', params: { id: $route.params.id } }"
            >
              <span class="button__text">Создать чемпионат</span>
            </router-link>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { filter, debounce, findIndex } from 'lodash'
import ChampCard from '@/components/ChampCard'
import Pagination from '@/components/Pagination'
import { scrollToId } from '@/assets/js/animation'
import champsService from '@/services/champsService'

export default {
  name: 'ManageChamps',
  components: {
    ChampCard,
    Pagination
  },
  data () {
    return {
      clubId: null,
      isSearching: false,
      loading: false,
      params: {
        search: null
      },
      pagination: {
        page: 0,
        itemsPerPage: 6,
        totalItems: 0,
        disabled: false
      },
      champsItems: null,
      empty: false,
      ready: false
    }
  },
  computed: {
    ...mapState('club', [
      'clubInfo'
    ]),
    ...mapState('user', [
      'user'
    ]),
    isLoaded () {
      return !!(this.ready && this.champsItems)
    },
    draftChamps () {
      const items = this.champsItems
      return items ? filter(items, (o) => o.Status === 1) : []
    },
    activeChamps () {
      const items = this.champsItems
      return items ? filter(items, (o) => o.Status === 2) : []
    },
    finishedChamps () {
      const items = this.champsItems
      return items ? filter(items, (o) => o.Status === 3) : []
    }
  },
  methods: {
    changePage (page) {
      this.pageChanging = true
      this.pagination.page = page
      this.loadItems()
    },
    search () {
      if (this.prevSearch === this.params.search) {
        return
      }
      this.prevSearch = this.params.search
      this.pagination.page = 0
      this.pagination.disabled = true
      this.loadItems()
    },
    loadItems () {
      this.loading = true

      champsService.getChamps({
        clubId: this.clubId,
        championshipsType: 1,
        userId: this.user.id,
        searchString: this.params.search,
        onlyActive: false,
        showDrafts: true,
        orderByStatus: true,
        skip: this.pagination.page * this.pagination.itemsPerPage,
        take: this.pagination.itemsPerPage
      })
        .then((res) => {
          const data = res.data

          this.loading = false
          this.champsItems = data.Championships
          this.pagination.totalItems = data.TotalCount
          this.pagination.disabled = false

          if (this.pageChanging) {
            this.$nextTick(() => {
              scrollToId('champs', undefined, 0)
            })
            this.pageChanging = false
          }

          if (!this.ready && data.TotalCount < 1) {
            this.empty = true
          }
          this.ready = true
        })
        .catch(response => {
          if (response.message !== 'canceled') {
            this.loading = false
          }
        })
    },
    onChampDelete (champId) {
      const index = findIndex(this.champsItems, (o) => o.Id === champId)
      this.champsItems.splice(index, 1)
      if (this.champsItems.length < 1) {
        this.pagination.page = 0
        this.champsItems = []
        this.pagination.totalItems = 0
        this.loadItems()
      }
    }
  },
  watch: {
    clubInfo: {
      handler (val) {
        if (!val) {
          return
        }
        this.clubId = val.id
        this.loadItems()
      },
      immediate: true
    },
    'params.search' () {
      this.debouncedSearch()
    }
  },
  created () {
    this.debouncedSearch = debounce(this.search, 1000)
  }
}
</script>
